import {
  setDoc,
  doc,
  collection,
  getDocs,
  updateDoc,
  getDoc,
} from "firebase/firestore/lite";
import { v4 } from "uuid";
import { db } from "@/firebase";
import { USERS, ADDRESSES } from "@/config/data/parameters";

async function get_user_data(user_id: string) {
    try {
        const docRef = doc(db, USERS, user_id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error getting user data:', error);
        return null;
    }
}

async function getSelectedAddressByUser(user_id: string, address_id: string) {
  const docRef = doc(db, USERS, user_id, ADDRESSES, address_id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
}

async function updateUserName(user_id: string, user_name: string) {
  try {
    const userRef = doc(db, USERS, user_id);
    await updateDoc(userRef, {
      name: user_name,
    });
  } catch (error) {
    console.error("Error updating user name", { user_id, error });
    throw error;
  }
}

async function writeNewAddress(user_id: string, address: any) {
  try {
    let addr = {
      ...address,
      id: address.id || v4(),
      createdAt: address.createdAt || Date.now(),
      updated_at: Date.now(),
      status: address.status || "active",
    };
    const docRef = doc(db, USERS, user_id, ADDRESSES, addr.id);
    await setDoc(docRef, addr, { merge: true });
    return addr;
  } catch (error) {
    console.error("Error writing address", { user_id, error });
    throw error; // o return null
  }
}

async function choseAddress(user_id: string, location: any) {
  try {
    const userRef = doc(db, USERS, user_id);
    const currentAddressInfo = {
      current_location_id: location.id,
      current_address_label: location.name,
      current_full_address: location.address,
      current_city_name: location.city.name,
      updated_at: Date.now(),
    };

    await updateDoc(userRef, {
      selected_location: currentAddressInfo,
    });
  } catch (error) {
    console.error("Error choosing address", { user_id, error });
    throw error;
  }
}

async function getAddresses(user_id: string) {
  try {
    const colRef = collection(db, USERS, user_id, ADDRESSES);
    const snapshot = await getDocs(colRef);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error getting addresses:", { user_id, error });
    return [];
  }
}

export {
  writeNewAddress,
  getAddresses,
  choseAddress,
  getSelectedAddressByUser,
  get_user_data,
  updateUserName
};
